import { APIClient } from "./apiCore";
import * as url from "./urls";
import { ProfileTypes } from "../data";
const api = new APIClient();

const createInvoice = (payload: any) => {
  const response: Promise<any> = api.create(url.CREATE_INVOICE, payload);
  return response;
};

const getAllInvoices = () => {
  const response: Promise<any> = api.get(url.GET_ALL_INVOICES);
  return response;
};

const getInvoice = (params: { invoiceId: string | undefined }) => {
  const response: Promise<any> = api.get(url.GET_INVOICE, params);
  return response;
};

const generateInvoicePDF = () => {
  const response: Promise<any> = api.get(url.GENERATE_INVOICE_PDF);
  return response;
};

const updateInvoice = (payload: any) => {
  const response: Promise<any> = api.create(url.UPDATE_INVOICE, payload);
  return response;
};

const deleteInvoice = (params: { invoiceId: string | undefined }) => {
  const response: Promise<any> = api.delete(url.DELETE_INVOICE, params);
  return response;
};

const markSent = (params: { invoiceId: string | undefined }) => {
  const response: Promise<any> = api.create(url.MARK_SENT, params);
  return response;
};

const markPaid = (params: { invoiceId: string | undefined }) => {
  const response: Promise<any> = api.create(url.MARK_PAID, params);
  return response;
};

const markCancel = (params: { invoiceId: string | undefined }) => {
  const response: Promise<any> = api.create(url.MARK_CANCEL, params);
  return response;
};

const deleteSelectedInvoices = (payload: any) => {
  const response: Promise<any> = api.update(
    url.DELETE_SELECTED_INVOICES,
    payload,
  );
  return response;
};

const sendEmail = (payload: any) => {
  const response: Promise<any> = api.create(url.SEND_EMAIL_INVOICE, payload);
  return response;
};

export {
  createInvoice,
  getAllInvoices,
  getInvoice,
  updateInvoice,
  deleteInvoice,
  deleteSelectedInvoices,
  generateInvoicePDF,
  sendEmail,
  markSent,
  markPaid,
  markCancel,
};
